export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70da9402afa92a0caad83fa42149735fb10e7f41ec&name=pushAdClickData!'